import React, { useState, useEffect } from "react";
import "../styles/GuideRegistration.css";
import emailjs from "@emailjs/browser";

export default function GuideRegistration() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
        places: "",
        description: "",
        languages: "",
        reviewLinks: "",
        baseFare: 1000,
        fareType: "per_day",
    });
    const [govtCertificate, setGovtCertificate] = useState(null);
    //const [aadhaarCard, setAadhaarCard] = useState(null);
    const [acceptedTC, setAcceptedTC] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [showTC, setShowTC] = useState(false);

    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        emailjs.init("SV0XPhI3tDyRALbSk");
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            alert("Passwords do not match!");
            return;
        }
        if (!acceptedTC) {
            alert("You must accept the Terms & Conditions to continue.");
            return;
        }
        try {
            const data = new FormData();
            Object.keys(formData).forEach((key) => {
                if (key !== "confirmPassword") {
                    data.append(key, formData[key]);
                }
            });
            if (govtCertificate) data.append("govtCertificate", govtCertificate);
            //if (aadhaarCard) data.append("aadhaarCard", aadhaarCard);

            const res = await fetch(`${API_URL}/register-guide`, {
                method: "POST",
                body: data,
            });

            const result = await res.json();

            if (res.ok) {
                setSubmitted(true);
                sendEmail(
                    "anjalipujala003@gmail.com",
                    "Admin",
                    "New Guide Registration Request",
                    `Guide "${formData.name}" has requested to register.`
                );
                sendEmail(
                    formData.email, // send to guide's email
                    formData.name,
                    "Welcome to Soulful Yatra!",
                    `Hi ${formData.name},\n\nThank you for registering as a guide on Soulful Yatra! Your profile will be reviewed shortly. We will notify you once it's approved.\n\nHappy guiding!\n\n– The Soulful Yatra Team`
                );
            } else {
                alert(result.error || "Failed to register guide");
            }
        } catch (err) {
            console.error(err);
            alert("Failed to register guide");
        }
    };

    const sendEmail = (email, name, subject, message) => {
        emailjs
            .send("service_npgj14s", "template_5671qrw", {
                email: email,
                message: message,
                subject: subject,
            })
            .then((response) => console.log("Email sent:", response))
            .catch((error) => console.error("Email error:", error));
    };

    if (submitted) {
        return (
            <div className="guide-thankyou-container">
                <div className="guide-tick-mark animated">✔️</div>
                <h2 className="guide-thankyou-title">Welcome Onboard!</h2>
                <p className="guide-thankyou-message">
                    Your profile will be reviewed soon. Start connecting with travelers and grow your bookings!
                </p>
            </div>
        );
    }

    return (
        <div className="guide-wrapper">
            <div className="guide-header">
                <h1 className="guide-logo-title">Soulful Yatra</h1>
                <p className="guide-member-count">
                    💡 Join a trusted community – <span className="highlight-member">100+ users</span> already booking and traveling with us!
                </p>
            </div>

            <div className="guide-benefits-box">
                <h2>Why Become a Guide?</h2>
                <ul>
                    <li><span className="benefit-icon">🌟</span> <strong>Get Noticed:</strong> Your profile is showcased to local and global travelers, boosting your visibility.</li>
                    <li><span className="benefit-icon">💸</span> <strong>Earn More:</strong> Set your own fare, receive bookings, and get paid fast after every tour.</li>
                    <li><span className="benefit-icon">🔖</span> <strong>Instant Bookings:</strong> Receive booking alerts directly to your phone — no waiting.</li>
                    <li><span className="benefit-icon">📈</span> <strong>Grow Reputation:</strong> Collect client reviews and ratings to unlock special perks and top spots in search results.</li>
                    <li><span className="benefit-icon">🤝</span> <strong>Supported by Us:</strong> Dedicated support, marketing of your profile, and features on popular travel platforms.</li>
                </ul>
                <div className="testimonial">
                    <p>“Registered last month, already led three tours! Easiest way to connect and earn.” <br />– Ramesh, Delhi</p>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="guide-form-register animated">
                <h2 className="guide-title-register">Quick Registration</h2>
                <input type="text" name="name" placeholder="Full Name" onChange={handleChange} required />
                <input type="email" name="email" placeholder="Email Address" onChange={handleChange} required />
                <input type="text" name="phone" placeholder="Phone Number" onChange={handleChange} required />

                <input type="password" name="password" placeholder="Password" onChange={handleChange} required />
                <input type="password" name="confirmPassword" placeholder="Confirm Password" onChange={handleChange} required />
                <input type="text" name="places" placeholder="Places You Guide (comma-separated)" onChange={handleChange} required />

                <textarea name="description" placeholder="Describe your guiding story and experience" onChange={handleChange}></textarea>
                <input type="text" name="languages" placeholder="Languages Spoken (comma-separated)" onChange={handleChange} />

                <input type="url" name="reviewLinks" placeholder="Review/Portfolio Links (Google/TripAdvisor)" onChange={handleChange} />

                <input type="number" name="baseFare" placeholder="Your Base Fare (INR)" value={formData.baseFare} onChange={handleChange} />
                <select name="fareType" value={formData.fareType} onChange={handleChange}>
                    <option value="per_day">Per Day</option>
                    <option value="half_day">Half Day</option>
                    <option value="per_person">Per Person</option>
                </select>

                <label>Govt Certificate (optional):</label>
                <input type="file" onChange={(e) => setGovtCertificate(e.target.files[0])} />
                {/*
                <label>Aadhaar Card (required):</label>
                <input type="file" onChange={(e) => setAadhaarCard(e.target.files[0])} required />*/}

                <div className="guide-tc-container">
                    <span onClick={() => setShowTC(true)}>Read Terms & Conditions</span>
                </div>

                <button type="submit" className='guide-submit-button pulse' disabled={!acceptedTC}>Register & Get Featured!</button>
            </form>

            {showTC && (
                <div className="guide-tc-popup">
                    <div className="guide-tc-content">
                        <h3>Terms & Conditions</h3>
                        <div className="guide-tc-scroll">
                            <ol>
                                <li><strong>Verification:</strong> All submitted documents are for verification and records only.</li>
                                <li><strong>Approval:</strong> Admin will approve/reject applications based on details and service needs.</li>
                                <li><strong>Service Responsibility:</strong> Provide safe, respectful, and professional services.</li>
                                <li><strong>Base Fare & Payments:</strong> Set your own fares and get paid after bookings (service fee applies).</li>
                                <li><strong>Reviews & Ratings:</strong> Good feedback improves your profile and earnings.</li>
                                <li><strong>Privacy:</strong> Personal info used only for booking/verification.</li>
                                <li><strong>Termination:</strong> Accounts may be suspended for not following guidelines.</li>
                            </ol>
                            <p>
                                By clicking <em>Agree & Continue</em>, you confirm you accept these terms.
                            </p>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "15px" }}>
                            <button onClick={() => setShowTC(false)} className="guide-tc-close">
                                Close
                            </button>
                            <button
                                onClick={() => {
                                    setAcceptedTC(true);
                                    setShowTC(false);
                                }}
                                className="guide-tc-agree"
                            >
                                Agree & Continue
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}
